import React from 'react'
import PageChrome from '../../common/PageChrome'
import BlogPage from './Blog'
import NewsletterSubscription from './BlogNewsletter'

export default function index() {
  return (
    <PageChrome>
      <BlogPage/>
      <NewsletterSubscription/>
    </PageChrome>
  )
}
